import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BhSharedModule } from '@bh/shared.module';

import { ContentComponent } from 'app/layout/components/content/content.component';

@NgModule({
    declarations: [
        ContentComponent
    ],
    imports     : [
        RouterModule,
        BhSharedModule
    ],
    exports     : [
        ContentComponent
    ]
})
export class ContentModule
{
}
